module.exports = __webpack_public_path__ + "img/NZ.d2ac42f6.svg";